import { useMemo } from 'react';
import { selectJustInTimeCalls } from 'redux/slices/callsSlice.slice';
import { useAppSelector } from 'redux/storeHooks';
import { ActiveCallsHealthCheckManager } from './ActiveCallsHealthCheckManager';
import { JustInTimeCallCard } from './JustInTimeCallCard';

/**
 * Renders draggable JIT call notification cards for active calls.
 *
 * @returns JIT cards and the active-calls health check manager.
 */
export const JustInTimeCallDisplay = () => {
  const justInTimeCalls = useAppSelector(selectJustInTimeCalls);

  const sortedCalls = useMemo(() => {
    return [...justInTimeCalls].sort((a, b) => {
      const timeA = a.timestamp || a.timeStarted || 0;
      const timeB = b.timestamp || b.timeStarted || 0;
      return timeB - timeA;
    });
  }, [justInTimeCalls]);

  return (
    <>
      {sortedCalls.map((call, index) => (
        <JustInTimeCallCard key={call.id} call={call} stackIndex={index} />
      ))}
      <ActiveCallsHealthCheckManager />
    </>
  );
};
